import React, { useState } from "react";
import { ChevronUp, ChevronDown, Plus, CheckCircle } from "lucide-react";

export default function DeliveryInstructions({
   isAdminView,
  isDelivered,
  instructionList,
  submittedInstruction,
  existingInstruction,
  fetchInstructions,
  submitInstruction,
  taskId,
}) {
  const [instructionOpen, setInstructionOpen] = useState(false);
  const [selectedInstruction, setSelectedInstruction] = useState(null);
  const [customInstruction, setCustomInstruction] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const instructionSubmitted = !!submittedInstruction;

  const handleSubmitInstruction = async () => {
    if (!selectedInstruction && !customInstruction) return;

    setSubmitting(true);
    try {
      await submitInstruction({
        taskId,
        instructionId: selectedInstruction || 8, // (Custom Message)
        extraMessege: customInstruction,
      });
    } finally {
      setSubmitting(false);
    }
  };

  /* SUBMITTED / EXISTING VIEW */

  if (!isDelivered && (submittedInstruction || existingInstruction)) {
    const data = submittedInstruction || existingInstruction;

    return (
      <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl shadow p-4 flex items-start gap-3">
        <div className="p-3 rounded-full bg-green-100">
          <CheckCircle size={18} className="text-green-600" />
        </div>

        <div className="flex-1">
          <p className="font-semibold">Delivery instruction sent</p>

          <p className="text-sm text-gray-700 mt-1">
            <strong>{data?.title}</strong>
          </p>

          {data?.customerMessage && (
            <p className="text-sm text-gray-500 mt-1">
              "{data.customerMessage}"
            </p>
          )}
        </div>
      </div>
    );
  }

  if (isAdminView) return null;
  
  if (isDelivered || instructionSubmitted) return null;

  return (
    <div className="bg-white max-w-md mt-4 mx-4 rounded-xl shadow p-4">
      <div className="flex items-start gap-3">
        <div className="p-3 rounded-full bg-gray-100">
          <Plus size={18} />
        </div>

        <div className="flex-1">
          <p className="font-semibold text-sm">Add delivery instructions</p>
          <p className="text-sm text-gray-500">
            Help your delivery partner reach you
          </p>
        </div>

        <button
          onClick={() => {
            setInstructionOpen((prev) => {
              const next = !prev;
              if (next && instructionList.length === 0) {
                fetchInstructions();
              }
              return next;
            });
          }}
          className="p-3 rounded-full bg-gray-100"
          style={{ transition: "none" }}
        >
          {instructionOpen ? (
            <ChevronUp size={18} />
          ) : (
            <ChevronDown size={18} />
          )}
        </button>
      </div>

      {instructionOpen && (
        <div className="mt-4 border-t pt-4 space-y-4">
          <p className="font-semibold text-sm">Select delivery instruction</p>

          <div className="overflow-x-auto overflow-y-hidden scrollbar-hide -mx-4 px-4">
            <div className="flex gap-3 pb-2 pt-2">
              {instructionList
                .sort((a, b) => {
                  if (a.pk_instruction_id === 8) return -1;
                  if (b.pk_instruction_id === 8) return 1;
                  return 0;
                })
                .map((item) => {
                  const isSelected =
                    selectedInstruction === item.pk_instruction_id;

                  return (
                    <button
                      key={item.pk_instruction_id}
                      onClick={() => {
                        setSelectedInstruction(item.pk_instruction_id);
                        setCustomInstruction("");
                      }}
                      className={`flex-shrink-0 min-w-[160px] h-[70px] text-left border rounded-xl px-2 py-1
              ${
                isSelected
                  ? "border-orange-500 bg-orange-50"
                  : "border-gray-200 bg-white"
              }`}
                      style={{ transition: "none" }}
                    >
                      <p className="font-semibold text-xs line-clamp-2">
                        {item.title}
                      </p>

                      {isSelected && (
                        <span className="block mt-1 text-[11px] font-semibold text-orange-600">
                          ✓ Selected
                        </span>
                      )}
                    </button>
                  );
                })}
            </div>
          </div>

          <textarea
  value={customInstruction}
  onChange={(e) => {
    setCustomInstruction(e.target.value);
    if (e.target.value) setSelectedInstruction(null);
  }}
  placeholder="Write custom instruction (optional)..."
  rows={2}
  className="w-full text-sm border rounded-lg p-3 resize-none focus:ring-2 focus:ring-orange-500"
/>

          <div className="flex justify-center">
            <button
              onClick={handleSubmitInstruction}
              disabled={
                submitting || (!selectedInstruction && !customInstruction)
              }
              className="w-[180px] py-3 rounded-xl text-sm font-semibold
                bg-orange-500 text-white disabled:opacity-60"
              style={{ transition: "none" }}
            >
              {submitting ? "Submitting..." : "Submit instructions"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
